<template>
  <div
    style="position:relative;height:100%;"
  >
    <div
        style="padding: 25px;text-align:left;z-index:10;border-bottom: 1px solid rgba(0,0,0,0.1);background:white;display: flex;padding-top: var(--mobile-padding-top, 25px);"
    >
        <h1
            style="flex-grow: 1;"
        >
            My Settings
        </h1>
        <v-btn
            v-if="$vuetify.breakpoint.xs"
            color="#D32F2F"
            dark
            @click="$emit('logout')"
        >
            <v-icon
                left
            >
                mdi-logout
            </v-icon>
            Log Out
        </v-btn>
    </div>
    <div
        class="standard-content"
        :class="{ 'mobile-content': $vuetify.breakpoint.xs}"
        style="padding: 25px;"
    >
        <v-card>
            <v-toolbar
                flat
                dense
            >
                Personally Identifiable Information
            </v-toolbar>
            <v-card-text>
                <v-alert
                    :value="true"
                    type="warning"
                    outline
                >
                    To update your Personally Identifiable Information, please contact your law office.
                </v-alert>
                <v-text-field
                    v-model="clientSettings.first_name"
                    label="First Name"
                    disabled
                />
                <v-text-field
                    v-model="clientSettings.middle_name"
                    label="Middle Name"
                    disabled
                />
                <v-text-field
                    v-model="clientSettings.last_name"
                    label="Last Name"
                    disabled
                />
                <v-text-field
                    v-model="clientSettings.cuid"
                    label="Unique Identifier"
                    disabled
                />
            </v-card-text>
        </v-card>
        <v-form ref="editForm">
            <v-card
                style="margin-top: 15px;"
            >
                <v-toolbar
                    flat
                    dense
                >
                    Contact Information
                </v-toolbar>
                <v-card-text>
                    <v-text-field
                        v-model="clientSettings.email"
                        label="Email (to change your e-mail, please contact us)"
                        disabled
                    />
                    <v-text-field
                        v-model="settings.phone"
                        :rules="settings.phone ? [v => /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/.test(v) || 'Phone Number must match ###-###-####, ##########, ### ### #### or any equivalent format'] : []"
                        label="Mobile Phone (to change your phone number, please contact us)"
                        :error-messages="errorMessages['phone']"
                        disabled
                    />
                </v-card-text>
            </v-card>
            <v-card
                style="margin-top: 15px;"
            >
                <v-toolbar
                    flat
                    dense
                >
                    Notification Preferences
                </v-toolbar>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 sm4>
                            <span>How would you like to receive notifications?<br />
                            <small>You will receive the following notifications:<br />
                                <ul>
                                <li>A new form is issued for completion</li>
                                <li>An existing form is reissued for completion</li>
                                <li>A new message has arrived</li>
                                <li>A form is approaching its expiry date</li>
                                </ul>
                            </small></span>
                        </v-flex>
                        <v-flex xs12 sm4>
                            <v-switch
                                v-model="settings.notify_by_email"
                                style="display:inline;text-align:center;"
                                label="Via E-mail"
                                :hint="settings.email"
                                persistent-hint
                            ></v-switch>
                        </v-flex>
                        <v-flex xs12 sm4>
                            <v-switch
                                v-model="settings.notify_by_phone"
                                style="display:inline;"
                                label="Via SMS"
                                :disabled="!settings.phone"
                                :hint="settings.phone"
                                persistent-hint
                            ></v-switch>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
            <v-card-actions>
                <div
                    style="padding: 15px;opacity: 0.7;font-size: 12px;"
                >
                    <span><b>{{app_name}}</b><br /></span>
                    v{{ version }}<br />
                    <a @click="$emit('showPrivacyPolicy')">Privacy Policy</a>
                </div>
                <v-spacer />
                <v-btn
                    color="primary"
                    dark
                    @click="save()"
                >
                    <v-icon
                        v-if="saved"
                        left
                        color="green"
                    >
                        check_circle
                    </v-icon>
                    Save Settings
                </v-btn>
            </v-card-actions>
        </v-form>
    </div>

    <v-dialog
      v-model="smsDialog"
      width="600"
    >
      <v-card>
        <v-card-text>
          <p>
            <div
                style="font-size: 18px; font-weight: bold;"
            >
                We've sent you a message to your phone number <b>{{ clientSettings.phone }}</b> to confirm that you would like to receive SMS messages from <b>{{ domainInfo.name }}</b>.
            </div>
            <br />
            <div>
                If you do not receive the message, please check that your phone number is correct and that you have not blocked messages from this number. You can also subscribe manually by texting <b>START</b> to <b>{{ domainInfo.text_number }}</b>.
            </div>
            <br />
            <div
                style="font-size: 12px;"
            >
                <i>Message and data rates may apply. You must subscribe from the phone number on your account. If you need to change your phone number, please contact {{domainInfo.name}}.</i>
            </div>
          </p>
        </v-card-text>
        <v-card-actions
          style="padding-left: 20px; padding-right: 20px;"
        >
          <v-spacer />
          <v-btn
            color="primary"
            flat
            @click="smsDialog = false"
          >
            OK
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'

export default {
    name: 'Settings',
    props: ['version'],
    data () {
        return {
            settings: [],
            clientSettings: [],
            loading: false,
            errorMessages: [],
            repeatEmail: '',
            saved: false,
            smsDialog: false
        }
    },
    created () {
        this.loadSettings()
    },
    computed: {
        domainInfo () {
            return this.getDomainInfo
        },
    },
    watch: {
        clientSettings () {
            this.settings = JSON.parse(JSON.stringify(this.clientSettings))
            this.repeatEmail = this.settings.email
        }
    },
    methods: {
        loadSettings () {
            this.loading = true
            api.userform.contactSettings.get('')
                .then(data => {
                    this.clientSettings = data
                    this.loading = false
                })
        },
        save () {
            if (this.$refs.editForm.validate()) {
                this.saved = false
                if (this.repeatEmail !== this.settings.email) {
                    this.errorMessages = []
                    this.errorMessages['email_repeat'] = "Your e-mails do not match."
                } else {
                    this.$emit('update:loading', true)
                    this.errorMessages = []
                    api.userform.contactSettings.save(this.settings, [400])
                        .then(data => {
                            this.saved = true
                            if (this.settings.notify_by_phone && !data.notify_by_phone) {
                                this.smsDialog = true
                            }
                        })
                        .catch(error => {
                            if (error.status === 400) {
                                this.errorMessages = error.data
                            }
                        })
                }
            }
        }
    }
}
</script>

<style scoped>

    .standard-content {
        max-height: calc(100vh - 93px);
        height:100%;
        overflow-y:auto;
        position: relative;
    }
    .mobile-content {
        max-height: calc(100vh - 93px - 56px - var(--mobile-padding-bottom, 0px)) !important;
        position: relative;
    }

</style>